export const DEFAULT_PERSON_PAYER = { id: -1, name: "Personne inconnue (Créditeur Externe)", is_managed: 0 };
export const DEFAULT_PERSON_BENEF = { id: -2, name: "Tiers inconnu (Débiteur Externe)", is_managed: 0 };

export const UNMANAGED_ACCOUNT_ID = -99;

export const PAYMENTS_MOD = ['CB', 'Espèces', 'Virement', 'Chèque', 'Prélèvement', 'Tickets restaurant', 'Autre']

export const FLOW_TYPES = [
  { code: 'D', label: 'Dépense' },
  { code: 'R', label: 'Recette' },
  { code: 'B', label: 'Les Deux' },
  { code: 'T', label: 'Transfert / Neutre' }, // Pour les retraits, virements internes
];

// --- CONSTANTES DE THÈME ---

export const THEMES = {
    BLUE: 'blue',
    GREEN: 'green',
    RED: 'red',
    ORANGE: 'orange',
    YELLOW: 'yellow',
};

// Définition des couleurs spécifiques à chaque thème
export const THEME_COLORS = {
    [THEMES.BLUE]: {
        // ... (Palette BLUE existante) ...
        primary: '#4DD0E1',     
        secondary: '#26C6DA',   
        accent: '#FFC107',      
        danger: '#dc3545',
        warning: '#FF9000',      
        success: '#28a745',     
        defaultButton: '#6c757d', 
        actionBlue: '#007bff',  
        chartBar: '#ff9800',    
        corbeilleBG: '#f8d7da', 
        corbeilleText: '#721c24', 
        text: '#333333',
        textbutton: '#333333',        
        textSecondary: '#FFFFFF', 
        textTerciary: '#333333',
        title: '#424242',
        background: '#fbfbfb', 
        backgroundnav: 'rgba(251, 251, 251, 0.7)', 
        mainBackground: '#F5F5F5', 
        navActive: '#B4E1FB',   
        inputBorder: '#D4D4D4', 
        inputBackground: '#FFFFFF', 
        formBackground: '#f9f9f9',
        logoText: '#333333',    
        logoAccent: '#4DD0E1',  
    },
    [THEMES.GREEN]: {
        // ... (Palette GREEN existante) ...
        primary: '#8BC34A',     
        secondary: '#66BB6A',   
        accent: '#D4D4D4',
        danger: '#dc3545',
        warning: '#FF9000',      
        success: '#28a745',     
        defaultButton: '#6c757d', 
        actionBlue: '#007bff',  
        chartBar: '#8BC34A',    
        corbeilleBG: '#fff3cd', 
        corbeilleText: '#856404', 
        text: '#333333',
        textbutton: '#333333',        
        textSecondary: '#FFFFFF',
        textTerciary: '#333333',
        title: '#424242',
        background: '#fbfbfb',
        backgroundnav: 'rgba(251, 251, 251, 0.7)',  
        mainBackground: '#F5F5F5',
        navActive: '#C8E6C9',   
        inputBorder: '#D4D4D4', 
        inputBackground: '#FFFFFF',
        formBackground: '#f9f9f9',
        logoText: '#333333',    
        logoAccent: '#8BC34A',  
    },
    [THEMES.RED]: { 
        primary: '#880E4F',     
        secondary: '#A52A2A',   
        accent: '#FFD700',      
        danger: '#dc3545',
        warning: '#FF9000',      
        success: '#28a745',     
        defaultButton: '#424242', 
        actionBlue: '#007bff', 
        chartBar: '#880E4F',    
        corbeilleBG: '#f8d7da',
        corbeilleText: '#721c24', 
        text: '#424242',
        textbutton: '#FFF',        
        textSecondary: '#FFFFFF',
        textTerciary: '#FFFFFF',
        title: '#F5F5F5',
        background: 'rgba(251, 251, 251, 1)',
        backgroundnav: 'rgba(251, 251, 251, 0.7)',  
        mainBackground: 'rgba(238, 238, 238, 0.9)', 
        navActive: '#d195a6ff',   
        inputBorder: '#B0B0B0', 
        inputBackground: '#FFFFFF', 
        formBackground: '#F5F5F5', 
        logoText: '#424242',    
        logoAccent: '#880E4F',  
    },
    [THEMES.ORANGE]: { // <-- NOUVELLE PALETTE ORANGÉE
        primary: '#FF9800',     // Orange Coucher de Soleil (Bouton Principal, Accents)
        secondary: '#FFAB40',   // Corail Doux (Barres, Couleurs Actives)
        accent: '#FFD700',      // Or/Jaune (pour le filtre actif)
        danger: '#dc3545',      // Rouge (standard)
        warning: '#FF9000',
        success: '#28a745',     // Vert (standard)
        defaultButton: '#6c757d', // Gris neutre
        actionBlue: '#007bff',  // Bleu pour l'action "Modifier la sélection"
        chartBar: '#FF9800',    // Orange pour le graphique
        corbeilleBG: '#fff3cd', // Jaune très clair (pour l'alerte corbeille)
        corbeilleText: '#856404', // Texte foncé
        text: '#424242',        // Gris Neutre (Texte principal)
        textbutton: '#424242',
        textSecondary: '#FFFFFF', // Texte sur fond coloré (Blanc)
        textTerciary: '#424242',
        title: '#424242',
        background: '#fbfbfb',  // Fond principal (Sidebar, En-tête de tableau)
        backgroundnav: 'rgba(251, 251, 251, 0.7)',
        mainBackground: '#EEEEEE', // Gris clair/blanc cassé (Fond de la zone principale, selon votre suggestion)
        navActive: '#FFE0B2',   // Orange très pâle (Fond Nav Actif)
        inputBorder: '#B0B0B0', // Bordure gris plus foncé
        inputBackground: '#FFFFFF', 
        formBackground: '#F5F5F5', // Fond de formulaire interne
        logoText: '#424242',    // Gris Neutre ("Mon Budget")
        logoAccent: '#FF9800',  // Orange ("App")
    },
    [THEMES.YELLOW]: { // <-- NOUVELLE PALETTE JAUNE
        // Couleurs de base
        primary: '#ffd64fe0',     // Jaune Doux / Moutarde Claire (Bouton Principal, Accents)
        secondary: '#ffd64fe0',   // Doré Clair (Barres, Couleurs Actives - Note: très clair pour être secondaire)
        accent: '#FFC107',      // Ambre (Filtre actif, contraste léger)
        // Couleurs de statut/boutons
        danger: '#dc3545',      // Rouge (standard)
        warning: '#FF9000',
        success: '#28a745',     // Vert (standard)
        defaultButton: '#6c757d', // Gris neutre
        actionBlue: '#007bff',  // Bleu pour l'action "Modifier la sélection"
        chartBar: '#FFD54F',    // Jaune pour le graphique
        corbeilleBG: '#fffde7', // Jaune très très pâle (alerte)
        corbeilleText: '#856404', // Texte foncé
        // Couleurs de fond/texte
        text: '#424242',        // Gris Neutre (Texte principal)
        textbutton: '#424242',
        textSecondary: '#000', // Texte sur fond coloré (Blanc)
        textTerciary: '#424242',
        title: '#424242',
        background: '#fbfbfb',  // Fond principal (Sidebar, En-tête de tableau)
        backgroundnav: 'rgba(251, 251, 251, 0.7)',
        mainBackground: '#EEEEEE', // Gris clair/blanc cassé (Fond de la zone principale)
        navActive: '#FFF8E1',   // Jaune très très pâle (Fond Nav Actif)
        inputBorder: '#B0B0B0', // Bordure gris plus foncé
        inputBackground: '#FFFFFF', 
        formBackground: '#F5F5F5', // Fond de formulaire interne
        logoText: '#424242',    // Gris Neutre ("Mon Budget")
        logoAccent: '#FFD54F',  // Jaune ("App")
    }
};
/**
 * Fonction utilitaire pour obtenir le chemin du logo selon le thème et le format.
 * @param {string} currentTheme - Le thème actuel ('blue' ou 'green').
 * @param {string} type - Le format du logo ('row' pour horizontal, 'column' pour vertical).
 * @returns {string} Le nom du fichier de l'image.
 */
export const getLogoPath = (currentTheme, type = 'row') => {
    const themeName = (
        currentTheme === THEMES.RED ? THEMES.RED : 
        currentTheme === THEMES.GREEN ? THEMES.GREEN :
        currentTheme === THEMES.ORANGE ? THEMES.ORANGE :
        currentTheme === THEMES.YELLOW ? THEMES.YELLOW :
        THEMES.BLUE
    );
    return `logo_${type}_${themeName}.png`; 
};

/**
 * Génère le style visuel d'une cellule de budget en fonction de sa valeur et de son contexte.
 * @param {number} value - La valeur de l'écart ou du montant.
 * @param {boolean} isIncome - Si la catégorie est une recette.
 * @param {boolean} isFuture - Si le mois n'est pas encore atteint.
 * @param {object} themeColors - Les couleurs du thème actuel.
 * @returns {object} Un objet de style CSS.
 */
export const getBudgetContextualStyle = (value, isIncome, isFuture, themeColors) => {
    // Cas 1 : Mois futur (Grisé)
    if (isFuture) {
        return {
            backgroundColor: '#f2f2f2',
            color: '#999',
            opacity: 0.8
        };
    }

    // Détermination de l'état (Positif/Négatif)
    // Pour une dépense : positif = économie (Vert), négatif = dépassement (Rouge)
    // Pour une recette : on considère généralement l'affichage en Vert (e8f5e9)
    const isNegative = !isIncome && value < 0;

    return {
        backgroundColor: isIncome 
            ? '#e8f5e9' 
            : (isNegative ? themeColors.danger + '20' : themeColors.success + '20'),
        color: isIncome 
            ? '#2e7d32' 
            : (isNegative ? themeColors.danger : themeColors.success),
    };
};